<template>
  <div class="side-bar">
    <c-dropdown match-trigger-width>
      <c-button
        stretch
        :style="{ padding: '1rem', display: 'flex', justifyContent: 'flex-start', maxHeight: '100%'}"
      >
        <img
          src="/logo.svg"
          :style="{ maxWidth: '10rem' }"
        >
      </c-button>
      <template #content>
        <c-card
          contains-list
        >
          <div :style="{ fontSize: $fontSizes[2], padding: '.4rem 1.4rem', color: $colors.grey.base }">
            {{ currentUser.email }}
          </div>
          <c-card-item
            title="Logout"
            @click="logout"
          />
        </c-card>
      </template>
    </c-dropdown>
    <c-card-item
      title="Home"
      icon="home"
      :active="$route.name === routeNames.home"
      :to="{ name: routeNames.home }"
    />
    <c-card-item
      title="Plans"
      icon="plan"
      :active="$route.name === routeNames.plans"
      :to="{ name: routeNames.plans }"
    />
  </div>
</template>

<script setup>
import CButton from 'shared/components/CButton.vue';
import CCard from 'shared/components/CCard.vue';
import CCardItem from 'shared/components/CCardItem.vue';
import CDropdown from 'shared/components/CDropdown.vue';
import { FIREBASE_APP, SUBSCRIPTION_MANAGER, USER_SERVICE } from 'shared/constants';
import { signOut } from 'shared/services/firebase';
import { inject } from 'vue';
import { useRouter } from 'vue-router';

import routeNames from '@/router/routes';

const { currentUser } = inject(USER_SERVICE);

const subscriptionManager = inject(SUBSCRIPTION_MANAGER);
const { auth } = inject(FIREBASE_APP);
const router = useRouter();

const logout = () => {
  subscriptionManager.unsubscribeAll();
  signOut(auth).then(() => {
    router.push('/');
  });
};
</script>

<style scoped lang="scss" type="text/scss">
  .side-bar {
    width: 25rem;
    background-color: #FBFBFA;
    padding: .8rem;
  }
</style>
